import React, { useEffect, useRef } from "react";

// assets
import "bootstrap/dist/js/bootstrap.bundle.min.js";
//
import { useTranslation } from "react-i18next";
import { Tooltip } from "bootstrap";

const ButtonCopy = ({
  text,
  copyValue,
  successMessage = null,
  errorMessage = null,
  timeHideTooltip = 2000,
  iconLeft = null,
  iconRight = null,
  ...props
}) => {
  const buttonRef = useRef(null);
  const tooltipInstance = useRef(null);
  const { t } = useTranslation();

  useEffect(() => {
    // Inicializar el tooltip
    tooltipInstance.current = new Tooltip(buttonRef.current, {
      title: "-",
      placement: "bottom",
      trigger: "manual",
      template: '<div class="tooltip custom-tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
    });

    return () => {
      // Destruir el tooltip cuando el componente se desmonta
      tooltipInstance.current.dispose();
    };
  }, []);

  const showTooltip = (message) => {
    tooltipInstance.current.setContent({ ".tooltip-inner": message });
    tooltipInstance.current.show();
  };

  const hideTooltip = () => {
    tooltipInstance.current.hide();
  };

  const copyToClipboard = async () => {
    buttonRef.current.disabled = true; // Deshabilita el botón

    try {
      await window.navigator.clipboard.writeText(copyValue);

      showTooltip(successMessage || t("component_button_copy.success"));
    } catch (err) {
      showTooltip(errorMessage || t("component_button_copy.error"));
    }

    setTimeout(() => {
      buttonRef.current.disabled = false; // Deshabilita el botón
      hideTooltip();
    }, timeHideTooltip);
  };

  return (
    <button onClick={copyToClipboard} {...props} ref={buttonRef}>
      {iconLeft}
      {text}
      {iconRight}
    </button>
  );
};

export default ButtonCopy;
